/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateClientDto
 */
export interface CreateUpdateClientDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    shortname: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    nip?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    pesel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    place: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    countryId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientDto
     */
    countryIsMain: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    numbers: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    flat: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientDto
     */
    internal: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    companyId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientDto
     */
    isRelated: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    dealGroupNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientDto
     */
    notToSymphony: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientDto
     */
    signContractBlock: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientDto
     */
    notSendMailFVS: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientDto
     */
    overduePaymentReminder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientDto
     */
    paymentRequest: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientDto
     */
    paymentRequestKRD: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientDto
     */
    paymentRequestBlockKRD: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateClientDto
     */
    interest: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateClientDto
     */
    language: CreateUpdateClientDtoLanguageEnum;
}


/**
 * @export
 */
export const CreateUpdateClientDtoLanguageEnum = {
    Pl: 'PL',
    En: 'EN'
} as const;
export type CreateUpdateClientDtoLanguageEnum = typeof CreateUpdateClientDtoLanguageEnum[keyof typeof CreateUpdateClientDtoLanguageEnum];


/**
 * Check if a given object implements the CreateUpdateClientDto interface.
 */
export function instanceOfCreateUpdateClientDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "shortname" in value;
    isInstance = isInstance && "postcode" in value;
    isInstance = isInstance && "place" in value;
    isInstance = isInstance && "street" in value;
    isInstance = isInstance && "countryId" in value;
    isInstance = isInstance && "countryIsMain" in value;
    isInstance = isInstance && "numbers" in value;
    isInstance = isInstance && "flat" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "internal" in value;
    isInstance = isInstance && "isRelated" in value;
    isInstance = isInstance && "dealGroupNumber" in value;
    isInstance = isInstance && "notToSymphony" in value;
    isInstance = isInstance && "signContractBlock" in value;
    isInstance = isInstance && "notSendMailFVS" in value;
    isInstance = isInstance && "overduePaymentReminder" in value;
    isInstance = isInstance && "paymentRequest" in value;
    isInstance = isInstance && "paymentRequestKRD" in value;
    isInstance = isInstance && "paymentRequestBlockKRD" in value;
    isInstance = isInstance && "interest" in value;
    isInstance = isInstance && "language" in value;

    return isInstance;
}

export function CreateUpdateClientDtoFromJSON(json: any): CreateUpdateClientDto {
    return CreateUpdateClientDtoFromJSONTyped(json, false);
}

export function CreateUpdateClientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateClientDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'shortname': json['shortname'],
        'nip': !exists(json, 'nip') ? undefined : json['nip'],
        'pesel': !exists(json, 'pesel') ? undefined : json['pesel'],
        'postcode': json['postcode'],
        'place': json['place'],
        'street': json['street'],
        'countryId': json['countryId'],
        'countryIsMain': json['countryIsMain'],
        'numbers': json['numbers'],
        'flat': json['flat'],
        'active': json['active'],
        'internal': json['internal'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'isRelated': json['isRelated'],
        'dealGroupNumber': json['dealGroupNumber'],
        'notToSymphony': json['notToSymphony'],
        'signContractBlock': json['signContractBlock'],
        'notSendMailFVS': json['notSendMailFVS'],
        'overduePaymentReminder': json['overduePaymentReminder'],
        'paymentRequest': json['paymentRequest'],
        'paymentRequestKRD': json['paymentRequestKRD'],
        'paymentRequestBlockKRD': json['paymentRequestBlockKRD'],
        'interest': json['interest'],
        'language': json['language'],
    };
}

export function CreateUpdateClientDtoToJSON(value?: CreateUpdateClientDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'shortname': value.shortname,
        'nip': value.nip,
        'pesel': value.pesel,
        'postcode': value.postcode,
        'place': value.place,
        'street': value.street,
        'countryId': value.countryId,
        'countryIsMain': value.countryIsMain,
        'numbers': value.numbers,
        'flat': value.flat,
        'active': value.active,
        'internal': value.internal,
        'companyId': value.companyId,
        'isRelated': value.isRelated,
        'dealGroupNumber': value.dealGroupNumber,
        'notToSymphony': value.notToSymphony,
        'signContractBlock': value.signContractBlock,
        'notSendMailFVS': value.notSendMailFVS,
        'overduePaymentReminder': value.overduePaymentReminder,
        'paymentRequest': value.paymentRequest,
        'paymentRequestKRD': value.paymentRequestKRD,
        'paymentRequestBlockKRD': value.paymentRequestBlockKRD,
        'interest': value.interest,
        'language': value.language,
    };
}

